import React, { memo, useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { Spacer, TextButtonLinkSeeAll } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectAutosaveActivityToDisplayInAutosave } from '../reducers/selectors';
import EmptyAutosaveActivity from './EmptyAutosaveActivity';
import UpcomingAutosaveActivity from './UpcomingAutosaveActivity';
const AutosaveActivitySection = () => {
    const navigation = useMainStackNavigation();
    const upcomingPaymentOrActivity = useAppSelector(selectAutosaveActivityToDisplayInAutosave);
    const handleSeeAll = useCallback(() => {
        navigation.navigateDeprecated('AutosaveActivities');
    }, []);
    return (<>
      <Spacer h={24}/>
      <SectionHeader horizontalMargins button={upcomingPaymentOrActivity ? <TextButtonLinkSeeAll onPress={handleSeeAll}/> : null}>
        Activity
      </SectionHeader>
      <Spacer h={16}/>
      {upcomingPaymentOrActivity ? (<UpcomingAutosaveActivity upcomingPaymentOrActivity={upcomingPaymentOrActivity}/>) : (<EmptyAutosaveActivity />)}
    </>);
};
export default memo(AutosaveActivitySection);
